import React, { memo, useEffect, useMemo, useState } from "react";
import styles from "./Compare.module.scss";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import Selection from "./compare-sections/selection/Selection";
import Styling from "./compare-sections/styling/Styling";
import Features from "./compare-sections/features/Features";
import Powertrains from "./compare-sections/powertrains/Powertrains";
import Packs from "./compare-sections/packs/Packs";
import { CompareContext } from "./CompareContext";
import { CollapseSection, trackExpandeditems } from "../../../../utils/tracking";
import { CarConfigLabel } from "../../../../utils/labelUtils";

const NUMBER_COLLAPSE_SECTIONS = 4;

export type Props = {
    openPacksByDefault?: boolean;
    initialGradeId?: string;
};

const Compare: React.FC<Props> = ({ initialGradeId, openPacksByDefault }) => {
    const [openedCollapses, setOpenedCollapses] = useState<string[]>(
        openPacksByDefault ? [CollapseSection.SectionPacks] : [],
    );
    const allExpanded = openedCollapses.length === NUMBER_COLLAPSE_SECTIONS;
    const [grades, setGrades] = useState<(string | undefined)[]>([initialGradeId, undefined]);
    const contextValue = useMemo(
        () => ({ grades, setGrades, openedCollapses, setOpenedCollapses }),
        [grades, setGrades, openedCollapses, setOpenedCollapses],
    );

    useEffect(() => {
        setGrades([initialGradeId, undefined]);
    }, [initialGradeId]);

    return (
        <CompareContext.Provider value={contextValue}>
            <div className={styles.wrapper}>
                <Text tag="h3" variant="apheleia-h4" className={styles.title}>
                    <CarConfigLabel label="carConfigLbxCompareTitle" />
                </Text>
                <div className={styles.container}>
                    <Button
                        variant="clean"
                        className={styles["expand-all"]}
                        onClick={() => {
                            trackExpandeditems(allExpanded);
                            setOpenedCollapses(
                                allExpanded
                                    ? []
                                    : [
                                          CollapseSection.SectionStyling,
                                          CollapseSection.SectionFeatures,
                                          CollapseSection.SectionPowertrains,
                                          CollapseSection.SectionPacks,
                                      ],
                            );
                        }}
                    >
                        <CarConfigLabel
                            label={allExpanded ? "carConfigLbxCompareCollapseAll" : "carConfigLbxCompareExpandAll"}
                        />
                        <Icon variant={allExpanded ? "minus" : "plus"} sizing="sm" aria-hidden="true" />
                    </Button>
                </div>

                <Selection />
                <Styling />
                <Features />
                <Powertrains />
                <Packs />
            </div>
        </CompareContext.Provider>
    );
};

export default memo(Compare);
